import styled from 'styled-components'
import { primaryColor } from 'style/_variables.js'

import { Modal } from '../Modal'

export const StyledContainer = styled.div`
		height: 360px;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
`

export const StyledModal = styled(Modal)`
		p {
			margin-top: 0;
		}
`

export const StyledField = styled.div`
		margin-bottom: 9px;
		padding-right: 9px;
		position: relative;
		display: block;
		max-width: 300px;
		button, .actions {
			right: 0;
			margin: 9px;
			margin-right: 18px;
			position: absolute;
			cursor: pointer;
		}
		.actions {
			top: 0;
			display: flex;
			align-items: center;
			gap: 8px;
			svg {
				width: 17px;
				height: 17px;
			}
		}
`

export const StyledNewField = styled(StyledField)`
path {
	stroke: #cdcdcd;
	// stroke-width: 0.3;
}`

export const StyledButton = styled.div`
		display: inline-block;
		background: ${primaryColor};
		color: #fff;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		padding-left: 4.5px;
		line-height: 0.9;
		cursor: pointer;
		vertical-align: middle;
`

